export const CONSTANTS =
{
    pageSize: 5,
    paginationMaxSize: 5,
    defaultPageSize: 10,
    maxPagesNumber: 7,
    otpCorrelationHeader: "X-Otp-Correlation-Id",

    spGroupName : 
    {
        CancellationGroup : "Adahi Cancellation",
        ExecutionPlanSupervisors : "Execution Plan Supervisors",
        RepresentativeManagement : "Adahi Representative Management",
        ContractManagement : "Adahi Contract Management",
        BatchNotification: "Adahi Batch Notification",
        AdahiCallCenter: "Adahi Call Center",
        ContentEditors: "Adahi Content Editors",
        AdahiOwners: "Adahi Owners",
        DistributionManager : "Adahi Distribution Managers",
        DistributionOfficer : "Adahi Distribution Officers",
        AdahiFinance: "Adahi Finance",
        AdahiMarketing: "Adahi Marketing"
    }
}
